<template>
<div v-role="'func'">
<div>
  <br>
  <v-card
    class="mx-auto"
    max-width="1200"
  >
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
    <v-card-text>
       <v-container fluid>
           <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

        <v-row>
            <v-col class="d-flex" cols="12" sm="12" md="11">
                <p class="display-1 text--primary">
                    Consultar meses não Pagos
                </p>
            </v-col>
            <v-col class="d-flex" cols="12" sm="1" md="1">
                <v-btn fab small :disabled="!estudantes_.length" @click="printDividaPdf()" color="red"><v-icon style="color:white;">print</v-icon></v-btn>
            </v-col>
        </v-row>
  </v-container>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div class="text--primary">

          <v-row>

               <v-col class="d-flex" cols="12" sm="6" md="6">

                <v-autocomplete
                  v-model="editedItem.objecto"
                  :items="turmas"
                  :loading="isLoading_"
                  :search-input.sync="search"
                  color="primary"
                  item-text="descricao"
                  item-value="descricao"
                  label="Descrição da turma"
                  placeholder="Digite a descrição da turma"
                  prepend-icon="mdi-database-search"
                  return-object
                  @change="turmaSelecionada()"
                ></v-autocomplete>

                </v-col>
                 

                 <v-col class="d-flex" cols="12" sm="6" md="2">
                   <v-btn :disabled="editedItem.objecto === null "  color="#006699"  fab small @click="save"  ><v-icon large color="white" >search</v-icon></v-btn>
                </v-col>
               <v-col class="d-flex" cols="12" sm="6" md="2">
                     <v-progress-circular
                    v-if="progresso"
                    indeterminate
                    color="green"
                ></v-progress-circular>
               </v-col>
          </v-row>
          <v-row>
                 <v-col class="d-flex" cols="12" sm="6" md="4">
                  <p>
                  <v-chip color='primary'> Curso:{{(this.editedItem.objecto !== null)?this.editedItem.objecto.descricao:''}}</v-chip>
                  </p>
                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                  <v-chip v-if="nivelEnsino === 1"> Anoacadémico: {{(this.editedItem.objecto !== null)?this.editedItem.objecto.classe+'º':''}}</v-chip>
                  <v-chip v-else> Classe: {{(this.editedItem.objecto !== null)?this.editedItem.objecto.classe:''}}</v-chip>
                  </p>
                </v-col>
               
                <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                   <v-chip>Anolectivo:{{(this.editedItem.objecto !== null)?this.editedItem.objecto.anolectivo:''}}</v-chip>
                  </p>
                </v-col>
                 

          </v-row>
          <v-row>
             <v-col class="d-flex" cols="12" sm="6" md="12">

                    <template>
                      <v-card
                        width="1200"
                        >
                        <v-toolbar
                          color="#006699"
                          dark
                        >
                          <v-app-bar-nav-icon></v-app-bar-nav-icon>

                          <v-toolbar-title>Resultado da pesquisa</v-toolbar-title>

                          <v-spacer></v-spacer>
                        </v-toolbar>
                          <v-card-text>
                            <v-row>
                              <v-col md="12">


                                  <v-data-table    :headers="headers"  :items="estudantes_" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
                                      <template v-slot:top>
                                        <v-toolbar flat color="white">
                                          <div class="flex-grow-1"></div>
                                          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
                                              <v-icon>cached</v-icon>
                                            </v-btn>
                                          <v-text-field
                                            v-model="searchInDb"
                                            append-icon="search"
                                            label="Pesquisa"

                                            single-line
                                            hide-details
                                          ></v-text-field>
                                          <!-- end  search  -->
                                        </v-toolbar>
                                      </template>
                                       <template v-slot:item.meses="{ item }">
                                        <span style="font-size:10px;">{{item.meses}}</span>
                                      </template>
                                       <template v-slot:item.precoPropina="{ item }">
                                        <span style="font-size:12px;">{{utilitarios.IntegerToMoneyValue(item.precoPropina)}}</span>
                                      </template>
                                       <template v-slot:item.precoUnitario="{ item }">
                                        <span style="font-size:12px;">{{utilitarios.IntegerToMoneyValue(item.precoUnitario)}}</span>
                                      </template>
                                      <template v-slot:item.multas="{ item }">
                                        <span style="font-size:12px;">{{utilitarios.IntegerToMoneyValue(item.multaTotal)}}</span>
                                      </template>
                                      <template v-slot:item.valorAPagar="{ item }">
                                        <span>{{utilitarios.IntegerToMoneyValueFatura(item.multaTotal+item.precoPropina)}}</span>
                                      </template>
                                      <template v-slot:item.action="{ item }">
                                        <v-menu
                                          bottom
                                          origin="center center"
                                          transition="scale-transition"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              fab dark small
                                              color="#006699"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon dark>menu</v-icon>
                                            </v-btn>
                                          </template>
                                          <v-list>
                                              <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small  >edit</v-icon>Editar</v-list-item>
                                              <v-list-item @click="setEliminar(item)"><v-icon color="red" small  >delete</v-icon>Eliminar</v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </template>
                                      <template v-slot:no-data>
                                    <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
                                    Clica em + para adicionar novo estudante
                                      </template>
                                    </v-data-table>



                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </template>

             </v-col>
             <v-col md="12">
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col md="8">
                        <span style="font-weight:bold;font-size:14px;"> Total de Dívida: </span>
                      </v-col>
                      <v-col md="4">
                         <span style="font-size:18px;font-weight:bold;">{{utilitarios.IntegerToMoneyValue(totalDivida)}}</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
             </v-col>

          </v-row>

      </div>
    </v-form>
    </v-card-text>
  </v-card>
</div>
</div>
</template>
<script>
import Vue from 'vue';
import axiosFinancas from '../../plugins/axiosFinancas'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')

export default {
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    estudantes_:[],
    utilitarios: utilitarios,
    turmasAll: [],
    listaDeClassesPorLancarNotas: [],
    turmasFiltered: [],
    precoMulta: [],
    ArraySemMultas: [],
    searchInDb: '',
    valid: true,
    overlay: false,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    arrMulta: [],
    multaTotal:0,
    estudantesMulta: [],
    classesFiltered: [],
    mensalidadesPagasColection: [],
    descriptionLimit: 60,
    entries: [],
    classes: [],
    mesesEmFalta: [],
    precoPropinas: [],
    multas: [],
    multasFiltered: [],
    estudantesNaoPagos:[],
    propinaFiltered:[],
    turmas: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    ruleRequired: [value => value || 'campo obrigatorio'],
    headers: [
      {
        text: 'Estudante',
        align: 'left',
        sortable: false,
        value: 'nome'
    },

      { text: 'Meses', value: 'meses' },
      { text: 'Preço unitário', value: 'precoUnitario' },
      { text: 'Subtotal', value: 'precoPropina' },
      { text: 'Multa', value: 'multas' },
      { text: 'Valor a Pagar', value: 'valorAPagar' },

    ],
  }),

  computed: {

    nivelEnsino () { // 1-  Ensino superior,  2- ensino Médio
      return ls.get('nivel')
    },

    anolectivo () {
      return ls.get('anolectivo')
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    mesesPrazo () {
      return ls.get('meses')
    },
    totalDivida() {
      let total = 0
        this.estudantes_.forEach(element => {
          total+= parseInt(element.valorAPagar)
        });

        return total

    },

    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 1) {
      // Items have already been requested
        if (!this.turmas.filter(t => t.descricao.includes(val)).length) {
          this.turmas = []
        }
        return this.initializeTurmas(val)
      }
    }

  },
  created () {
      this.initializeMultasExistentes()
      this.initializePrecoPropinas()
      this.mensalidadesPagas()
  },

  methods: {

    async mensalidadesPagas(){

     try {
        this.overlay = true
         this.mensalidadesPagasColection = await axios
          .get('/mensalidadesPagasAll')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
         Swal.fire('Informação','Ocorreu um erro ao tentar carregar as mensalidades','error')
      }

    },

    async initializeMultasExistentes () {
      try {
        this.isLoading = true
        this.multas = await axios
          .get('/valoresMultaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializePrecoPropinas () {
      try {
        this.isLoading = true
        this.precoPropinas = await axios
          .get('/produtosFindall-propinas')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
         Swal.fire('Informação','Ocorreu um erro ao durante o carregamento dos preços da propina','error')
       }
    },

    printDividaPdf (){
      this.overlay = true;
      try {
        ls.set('estudantes_',this.estudantes_)
        ls.set('turma',this.editedItem.objecto)
        ls.set('totalMulta',this.totalDivida)

        /*
            Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
            uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
            temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
            escola sem interferir na página atual.
          */
        
          import('./pdf_meses_nao_pagos.vue').then((module) => {
            const SegundaPagina = module.default;
            const tempInstance = new Vue({
              render: (h) => h(SegundaPagina),
            });
            tempInstance.$mount();
          })
        //this.$router.push('print-meses-nao-pagos')        
      } catch (error) {
        Swal.fire('Informação','Ocorreu um erro durante a impressão!','info')
        
      } finally {
        this.overlay = false;
      }
    },

    async initializeTurmas (payload) {
      try {
        this.isLoading = true
        this.turmas = await axiosFinancas
          .post('/turmasFindAllsearchBy',{descricao:payload})
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaSelecionada () {
       this.precoMulta = this.multas.filter( m=>m.curso_id === this.editedItem.objecto.curso_id && m.classe_id === this.editedItem.objecto.classe_id )
       this.propinaFiltered = this.precoPropinas.filter ( p=>p.curso_id ===  this.editedItem.objecto.curso_id && p.classe_id === this.editedItem.objecto.classe_id)
       if(this.propinaFiltered.length)
         {
           this.ListarEstudantesTurma(this.editedItem.objecto.id, this.propinaFiltered[0].precoVenda).then(res=>{})
         }
        else
           Swal.fire('Informação','Deve registrar o valor da propina para este curso e ano académico','info')
    },

    async ListarEstudantesTurma(turmaId, precoPropina){
        try {
          this.overlay = true
          this.estudantes = await axiosFinancas
            .get('/estudantesFindAllByTurma/'+turmaId)
            .then(res => res.data)
            this.verificaMensalidadesPagas(precoPropina).then(res=>{
             setTimeout(() => {
                  this.overlay = false
                //remove os que não têm multa
             }, 4000);
            })
            console.log(this.estudantes.length);
        } catch (error) {
          this.overlay = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
    },

    async verificaMensalidadesPagas (precoPropina) {
      this.estudantes_ = []
        this.estudantes.forEach(async element =>{
            let index_ = this.estudantes.indexOf(element)
            let mesesAPagar = this.getMesesAPagar()
           let mesesPagos = await this.MensalidadesPagasPorEstudante(element.bi.replaceAll('-',''))
            mesesPagos.forEach(mesPago => {
                let mensalidadePaga = mesesAPagar.filter( f=>parseInt(f) === parseInt(mesPago.fkMes) )
                if(mensalidadePaga.length){
                  let index = mesesAPagar.indexOf(parseInt(mesPago.fkMes))
                  mesesAPagar.splice(index,1)
                }
            });
            let mesesPorPagar =  this.ObterMesesDescricao(mesesAPagar)
            this.estudantes[index_].meses = mesesPorPagar
            this.estudantes[index_].multas = (this.arrMulta[0]*this.arrMulta.length)
            this.estudantes[index_].precoUnitario = precoPropina
            this.estudantes[index_].precoPropina = (precoPropina*mesesPorPagar.length)
            this.estudantes[index_].multaTotal = this.multaTotal
            this.estudantes[index_].valorAPagar = ((precoPropina)+this.multaTotal)
            this.arrMulta = [] 
            this.multaTotal = 0
            // Sem meses a pagar
            if(!mesesPorPagar.length){
              this.estudantes[index_].meses = "Sem dívida - Meses todos pagos"
            } 
            this.estudantes_.push(this.estudantes[index_])               
        });
    },

    getMesesAPagar () {
       let meses = ls.get('meses')
       let meses_ = []
       meses.forEach(element => {
        if(utilitarios.ObterAnoByDate(element.data1) === parseInt(this.anolectivo))
            meses_.push(element.fkMes)
       });
       return meses_;
    },

    async MensalidadesPagasPorEstudante(bi){
        return this.mensalidadesPagasColection.filter(c=>c.nif === bi)
    },

   
    ObterMesesDescricao (meses){
       let arr = []
        meses.forEach(element => {
            let valor = utilitarios.RetornaArrayMulta(element,this.precoMulta,this.mesesPrazo) 
            this.multaTotal+=valor

             switch (element) {
              case 1:
                if(valor >0){
                  this.arrMulta.push(valor) 
                }
                arr.push('Janeiro')
                break;
              case 2:
                arr.push('Fevereiro');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 3:
                arr.push('Março');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 4:
                arr.push('Abril');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 5:
                arr.push('Maio');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 6:
                arr.push('Junho');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 7:
                arr.push('Julho');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 8:
                arr.push('Agosto');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 9:
                arr.push('Setembro');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 10:
                arr.push('Outubro');
                if(valor >0) {this.arrMulta.push(valor)}
                else {this.arrMulta.push(valor)} // Não deve apenas contar as
                 
                break;
              case 11:
                arr.push('Novembro');
                if(valor >0){this.arrMulta.push(valor)}
                break;
              case 12:
                arr.push('Dezembro');
                if(valor >0){this.arrMulta.push(valor)}
                break;
             }
        });
       return arr
    },

  }
}
</script>
